<template>
	<div class="work-order">
		<el-form label-width="90px" :model="model" :rules="addRules" ref="form">
			<el-form-item label="工单类型：" prop="orderType">
				<el-select v-model="model.orderType" placeholder="请选择" size="mini">
					<el-option v-for="item in orderTypeList" :key="item.enumValue" :label="item.enumName" :value="item.enumValue"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="子类型：" prop="orderSubType">
				<el-select v-model="model.orderSubType" placeholder="请选择" size="mini">
					<el-option v-for="item in orderSubTypeList" :key="item.enumValue" :label="item.enumName" :value="item.enumValue"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="工单标题：" prop="orderTitle">
				<el-input v-model="model.orderTitle" maxlength="15" size="mini"></el-input>
			</el-form-item>
			<el-form-item label="问题描述：" prop="orderContent">
				<el-input v-model="model.orderContent" type="textarea" maxlength="150"></el-input>
			</el-form-item>
			<el-form-item label="上传附件：">
				<el-upload class="upload-demo" ref="upload" :action="actionPath" :multiple="false" :data="postData" :on-change="changeUpload" :on-success="uploadSuccess" :on-error="uploadFail" :auto-upload="false">
					<el-button size="mini" type="primary">点击上传</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item label="联系人：">
				<el-input v-model="model.contactUserName" maxlength="30" size="mini"></el-input>
			</el-form-item>
			<el-form-item label="联系电话：">
				<el-input v-model="model.contactUserPhone" maxlength="15" size="mini"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="mini" @click="submitWorkOrder">创建工单</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'wxWorkOrder',
	data () {
		return {
			actionPath: '//upload.qiniup.com',
			postData: {},
			domain: '',
			orderTypeList: [],
			orderSubTypeList: [],
			fileList: [],
			model: {
				orderType: '',
				orderSubType: '',
				orderTitle: '',
				orderContent: '',
				contactUserName: '',
				contactUserPhone: ''
			},
			addRules: {
				orderType: [
					{required: true, message: '请选择类型', trigger: 'change'}
				],
				orderSubType: [
					{required: true, message: '请选择类型', trigger: 'change'}
				],
				orderTitle: [
					{required: true, message: '请输入工单标题', trigger: 'blur'}
				],
				orderContent: [
					{required: true, message: '请输入问题描述', trigger: 'blur'}
				]
			}
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	watch: {
		currentShop: {
			deep: true,
			immediate: true,
			handler (now, old) {
				if (old && (now.id == old.id || !now.id)) return;
				this.getOrderList();
			}
		}
	},
	methods: {
		// 获取工单类型
		getOrderList () {
			var self = this,
				data = {
					serviceType: self.currentShop.serviceType
				};

			self.$axios.post(API_ROOT.url + '/SessionApi.getWorkOrderInfo', data).then(result => {
				if (result.status) {
					if (result.data.orderTypeList) self.orderTypeList = result.data.orderTypeList;
					if (result.data.subOrderTypeList) self.orderSubTypeList = result.data.subOrderTypeList;
				} else {
					self.$alert('获取工单类型失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('获取工单类型失败，错误码(' + response + ')');
			})
		},

		// 上传前
		changeUpload (file) {
			var self = this,
				fileName = file.name,
				index = fileName.lastIndexOf("."),
				data = {
					prefix: fileName.substring(0, index),
					ext: fileName.substring(index + 1, fileName.length)
				};

			if (file.response) return;

			var newData = "";
			for(var i in data){
				newData += i + "=" + data[i] + "&";
			}
			newData = newData.substring(0, newData.length - 1);

			self.$axios.request({
				url : API_ROOT.uploadUrl + '/raw/img/qiniuToken', 
				data : newData,
				headers: {'Content-Type': 'application/x-www-form-urlencoded'},
				method: 'post'
			}).then(result => {
				if (result.status) {
					self.domain = result.data.data.domain;
					self.postData.token = result.data.data.token;
					self.postData.key = result.data.data.key;
					self.$refs.upload.submit();
				} else {
					self.$alert('获取七牛token失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('获取七牛token失败，错误码(' + response + ')');
			})
		},

		// 上传成功
		uploadSuccess (rsp, file, fileList) {
			var self = this;

			self.fileList = fileList;
		},

		// 上传失败
		uploadFail (err, file, fileList) {
			var self = this;

			self.$alert(file.name + '上传失败');
		},

		// 提交工单
		submitWorkOrder () {
			var self = this,
				data = {
					contactUserPhone: self.model.contactUserPhone,
					contactUserName: self.model.contactUserName,
					orderContent: self.model.orderContent,
					orderTitle: self.model.orderTitle,
					orderSubType: self.model.orderSubType,
					orderType: self.model.orderType,
					orderSuperType: 1,
					shopId: self.currentShop.id,
					onlineChatSessionId: self.currentConversation.id
				};

			for (var i = 0; i < self.fileList.length; i++) {
				var fileObj = self.fileList[i];
				data['attachmentList[' + i + '].fileName'] = fileObj.name;
				data['attachmentList[' + i + '].filePath'] = self.domain + '/' + fileObj.response.key;
			}

			var newData = "";
			for(var i in data){
				newData += i + "=" + data[i] + "&";
			}
			newData = newData.substring(0, newData.length - 1);

			self.$refs['form'].validate((valid) => {
				if (!valid) return;

				self.$axios.request({
					url : API_ROOT.uploadUrl + '/raw/workOrder/create', 
					data : newData,
					headers: {'Content-Type': 'application/x-www-form-urlencoded'},
					method: 'post'
				}).then(result => {
					self.$alert(result.message);
					if (result.status) {
						try {
						self.$refs['form'].resetFields();
						} catch(e) {}
					}
				}, response => {
					self.$alert('创建工单失败，错误码(' + response + ')');
				})
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/wxWorkOrder.vue